/* eslint-disable indent */
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import usersService from '@/services/users/'
import createPersistedState from 'vuex-persistedstate'
import _ from 'lodash'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        status: '',
        token: localStorage.getItem('token') || '',
        user: {},
        inCart: [],
        historicCart: [],
        printPreview: []
    },
    plugins: [createPersistedState()],
    mutations: {
        auth_request (state) {
            state.status = 'loading'
        },
        auth_success (state, payload) {
            state.status = 'success'
            state.token = payload.token
            state.user = payload.userInfo
        },
        auth_error (state) {
            state.status = 'error'
        },
        logout (state) {
            state.status = ''
            state.token = ''
            state.user = {}
        },
        INIT_CART (state, item) {
            state.inCart.push(item)
        },
        ADD_TO_CART (state, item) {
            var product = item
            product.uuid = Date.now()
            state.inCart[0].products.push(product)
        },
        REMOVE_FROM_CART (state, index) {
            state.inCart[0].products.splice(index, 1)
        },

        REMOVE_FROM_CHECKOUT (state, index) {
            var filteredProducts = state.inCart[0].products.filter(function (product) {
                return index.item.uuid !== product.uuid
            })

            state.inCart[0].products = filteredProducts
        },
        UPDATE_CART (state, payload) {
            state.inCart[0].products[payload.index] = payload.item
        },
        EMPTY_CART (state) {
            state.inCart = []
        },
        ADD_TO_HISTORIC_CART (state, item) {
            var product = item
            product.uuid = Date.now()
            state.historicCart[0].products.push(product)
        },
        LOAD_HISTORIC_CART (state, items) {
            _.forEach(items.products, product => {
                product.uuid = product.item_id
            })
            state.historicCart.push(items)
        },
        REMOVE_FROM_HISTORIC_CART (state, index) {
            var filteredProducts = state.historicCart[0].products.filter(function (product) {
                return index.item.uuid !== product.uuid
            })

            state.historicCart[0].products = filteredProducts
        },
        UPDATE_HISTORIC_CART (state, payload) {
            state.historicCart[0].products[payload.index] = payload.item
        },
        EMPTY_HISTORIC_CART (state) {
            state.historicCart = []
        },
        PRINT_PREVIEW (state, payload) {
            state.printPreview = payload
        }
    },
    actions: {
        login ({
            commit }, user) {
            return new Promise((resolve, reject) => {
                commit('auth_request')
                usersService
                    .authenticate(user)
                    .then(resp => {
                        const token = resp.data.token
                        var userInfo = {
                            userId: resp.data.user_id,
                            role: resp.data.role_name,
                            roleId: resp.data.users_roles_id,
                            firstName: resp.data.first_name,
                            lastName: resp.data.last_name,
                            organizationId: resp.data.organization_id
                        }
                        localStorage.setItem('token', token)
                        localStorage.setItem('user', JSON.stringify(userInfo))
                        axios.defaults.headers.common['Authorization'] = token
                        commit('auth_success', { token, userInfo })
                        resolve(resp)
                    })
                    .catch(err => {
                        commit('auth_error')
                        localStorage.removeItem('token')
                        localStorage.removeItem('user')
                        reject(err)
                    })
            })
        },

        logout ({
            commit }) {
            return new Promise((resolve, reject) => {
                commit('logout')
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                delete axios.defaults.headers.common['Authorization']
                commit('EMPTY_HISTORIC_CART')
                commit('EMPTY_CART')
                resolve()
            })
        },

        initCart (context, order) {
            context.commit('EMPTY_CART')
            context.commit('INIT_CART', order)
        },

        addToCart (context, item) {
            context.commit('ADD_TO_CART', item)
        },

        removeFromCart (context, index) {
            context.commit('REMOVE_FROM_CART', index)
        },

        removeFromCheckout (context, index) {
            context.commit('REMOVE_FROM_CHECKOUT', index)
        },

        updateCart (context, payload) {
            context.commit('UPDATE_CART', payload)
        },

        emptyCart (context) {
            context.commit('EMPTY_CART')
        },

        loadHistoricCart (context, items) {
            context.commit('LOAD_HISTORIC_CART', items)
        },

        addToHistoricCart (context, item) {
            context.commit('ADD_TO_HISTORIC_CART', item)
        },

        removeFromHistoricCart (context, index) {
            context.commit('REMOVE_FROM_HISTORIC_CART', index)
        },

        updateHistoricCart (context, payload) {
            context.commit('UPDATE_HISTORIC_CART', payload)
        },

        emptyHistoricCart (context) {
            context.commit('EMPTY_HISTORIC_CART')
        },

        printPreview (context, payload) {
            context.commit('PRINT_PREVIEW', payload)
        }
    },
    getters: {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        user: state => state.user,
        inCart: state => state.inCart,
        historicCart: state => state.historicCart,
        printPreview: state => state.printPreview
    }
})
